import React from 'react';

import {
  edit_profile_settings_path,
  forum_path,
  subscriber_directories_path,
} from '../../../routes';
import StepContainer from './StepContainer';

const StepComplete = ({ nextStep }) => {
  return (
    <StepContainer heading="Your profile is enabled" subheading="Explore our community">
      <div className="content-wrapper">
        <div className="complete-links">
          <a className="complete-link" href={edit_profile_settings_path()}>
            <div className="link-text">Complete your subscriber profile</div>
            <div className="chevron-right">&gt;</div>
          </a>
          <a className="complete-link" href={subscriber_directories_path()}>
            <div className="link-text">Search the subscriber directory</div>
            <div className="chevron-right">&gt;</div>
          </a>
          <a className="complete-link" href={forum_path()}>
            <div className="link-text">Check out the subscriber forum</div>
            <div className="chevron-right">&gt;</div>
          </a>
        </div>
        <button
          onClick={nextStep}
          className="button button-red button-stretch button-small continue-button"
        >
          Done for Now
        </button>
      </div>
    </StepContainer>
  );
};

export default StepComplete;
